import getLocalString from "constants/Localization";
import { useCreateOrganizationCustomContentTypeMutation } from "generated/graphql";
import useBitumioMutation from "hooks/useBitumioMutation";

export default function useCreateOrganizationCustomContentType() {
  const [mutation, { loading, data, error }] = useCreateOrganizationCustomContentTypeMutation({
    refetchQueries: [
      "getOrganizationProposalLayoutContentSettings",
      "getOrganizationProposalContent",
    ],
  });

  const [createOrganizationCustomContentType, context] = useBitumioMutation(
    {
      mutation,
      loading,
      data,
      error,
      key: "createOrganizationCustomContentType",
    },
    {
      successMessage: getLocalString("organization.create-custom-content-type-success"),
      failureMessage: getLocalString("organization.create-custom-content-type-failure"),
    }
  );

  return [createOrganizationCustomContentType, context] as const;
}
